<template>
  <div class="table-responsive project-list">
    <table class="table table-striped">
      <thead>
      <tr>
        <th class="col-xs-3">Subject</th>
        <th class="col-xs-7">Message</th>
        <th class="col-xs-2 text-center">Date</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(notification, key) in notifications" :key="key">
        <td>
          <template v-if="notification.link !== null && notification.link.search('http') === 0">
            <a :href="notification.link" target="_blank">
              {{notification.title}}
            </a>
          </template>
          <router-link v-else :to="{path: notification.link}" :key="key">
            {{notification.title}}
          </router-link>
        </td>
        <td>{{notification.content}}</td>
        <td class="text-center"><small><i class="fa fa-clock-o"></i> {{notification.created_at | moment('LLL')}}</small></td>
      </tr>
      <tr v-if="notifications.length === 0">
        <td colspan="3" class="text-center"> empty data</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style>
</style>

<script>

export default {
  components: {
  },
  props: ['projects'],
  name: 'RecentlyNotifications',
  methods: {
    getResources: function () {
      this.axios.get('/dashboard/notifications').then((response) => {
        this.notifications = response.data
      })
    }
  },
  data () {
    return {
      notifications: []
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/notification/RecentlyNotifications.vue